module.exports = __webpack_public_path__ + "static/media/5.66a4a56a.jpg";